/* ==========================================================================
   DH COLLECTION PAGINATION

   Lightweight Daisy & Hen collection pagination enhancement.

   Horizon owns:
   - Infinite scroll
   - Product queries
   - Filters
   - Sorting
   - Product-card rendering

   DH owns:
   - Optional Load More
   - Back to Top

   No external libraries.
   ========================================================================== */

(function () {
  'use strict';


  /* ==========================================================================
     PREVENT DUPLICATE INITIALISATION
     ========================================================================== */

  if (window.DHCollectionPaginationInitialised) {
    return;
  }

  window.DHCollectionPaginationInitialised = true;


  /* ==========================================================================
     FIND RESULTS LIST FOR SECTION
     ========================================================================== */

  function getCurrentResultsList(sectionId) {

    var resultsLists =
      document.querySelectorAll('results-list');


    for (
      var i = 0;
      i < resultsLists.length;
      i++
    ) {

      if (
        resultsLists[i].getAttribute('section-id') === sectionId
      ) {
        return resultsLists[i];
      }

    }


    return null;
  }


  /* ==========================================================================
     LOAD MORE
     ========================================================================== */

  async function loadMoreProducts(link) {

    if (!(link instanceof HTMLAnchorElement)) {
      return;
    }


    var pagination =
      link.closest(
        '[data-dh-collection-pagination]'
      );


    if (!pagination) {
      return;
    }


    var sectionId =
      pagination.getAttribute(
        'data-section-id'
      );


    var nextUrl =
      link.getAttribute('href');


    if (!sectionId || !nextUrl) {
      return;
    }


    if (
      link.getAttribute('aria-busy') === 'true'
    ) {
      return;
    }


    var label =
      link.querySelector(
        '[data-dh-load-more-label]'
      );


    var originalLabel =
      label
        ? label.textContent
        : 'Load more';


    link.setAttribute(
      'aria-busy',
      'true'
    );


    if (label) {
      label.textContent = 'Loading…';
    }


    try {

      var requestUrl =
        new URL(
          nextUrl,
          window.location.origin
        );


      requestUrl.searchParams.set(
        'section_id',
        sectionId
      );


      var response =
        await fetch(
          requestUrl.toString(),
          {
            method: 'GET',
            credentials: 'same-origin',

            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );


      if (!response.ok) {
        throw new Error(
          'Unable to load more products.'
        );
      }


      var html =
        await response.text();


      var parsedDocument =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );


      var currentResultsList =
        getCurrentResultsList(
          sectionId
        );


      var currentGrid =
        currentResultsList
          ? currentResultsList.querySelector(
              '[data-testid="product-grid"]'
            )
          : null;


      var nextGrid =
        parsedDocument.querySelector(
          '[data-testid="product-grid"]'
        );


      if (!currentGrid || !nextGrid) {
        throw new Error(
          'Product grid could not be found.'
        );
      }


      var nextItems =
        nextGrid.querySelectorAll(
          ':scope > li'
        );


      if (!nextItems.length) {
        throw new Error(
          'No additional products were returned.'
        );
      }


      var fragment =
        document.createDocumentFragment();


      nextItems.forEach(
        function (item) {

          fragment.appendChild(
            document.importNode(
              item,
              true
            )
          );

        }
      );


      currentGrid.appendChild(
        fragment
      );


      var nextPagination =
        parsedDocument.querySelector(
          '[data-dh-collection-pagination]'
        );


      if (!nextPagination) {
        throw new Error(
          'Pagination state could not be found.'
        );
      }


      pagination.replaceWith(
        document.importNode(
          nextPagination,
          true
        )
      );


    } catch (error) {

      link.removeAttribute(
        'aria-busy'
      );


      if (label) {
        label.textContent =
          originalLabel;
      }


      console.error(
        '[DH Collection Pagination]',
        error
      );

    }

  }


  /* ==========================================================================
     BACK TO TOP
     ========================================================================== */

  function backToTop() {

    var target =
      document.getElementById(
        'ResultsList'
      );


    if (!target) {
      return;
    }


    var reduceMotion =
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    target.scrollIntoView({
      behavior:
        reduceMotion
          ? 'auto'
          : 'smooth',

      block: 'start'
    });

  }


  /* ==========================================================================
     EVENT DELEGATION
     ========================================================================== */

  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;


      if (!(target instanceof Element)) {
        return;
      }


      var loadMore =
        target.closest(
          '[data-dh-load-more]'
        );


      if (loadMore) {

        event.preventDefault();

        loadMoreProducts(
          loadMore
        );

        return;
      }


      var backToTopControl =
        target.closest(
          '[data-dh-back-to-top]'
        );


      if (backToTopControl) {

        event.preventDefault();

        backToTop();

      }

    }
  );

})();